import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/assetWarrantyExpiryReport'
import Component from 'components/Reports/AssetWarrantyExpiryReport'

export default createListViewContainer({ actions, selectors: selectors.assetWarrantyExpiryReport })(Component)
